import {
  FETCH_FEEDBACK_INSIGHTS_OVERVIEW,
  FEEDBACK_INSIGHTS_OVERVIEW_LOADED,
  FEEDBACK_INSIGHTS_OVERVIEW_FAILED,
  FETCH_FEEDBACK_INSIGHTS_RATING_TREND,
  FEEDBACK_INSIGHTS_RATING_TREND_LOADED,
  FEEDBACK_INSIGHTS_RATING_TREND_FAILED,
  FETCH_FEEDBACK_INSIGHTS_SERVICE_PERIOD,
  FEEDBACK_INSIGHTS_SERVICE_PERIOD_LOADED,
  FEEDBACK_INSIGHTS_SERVICE_PERIOD_FAILED,
  FETCH_FEEDBACK_INSIGHTS_OUTLET_COMPARISON,
  FEEDBACK_INSIGHTS_OUTLET_COMPARISON_LOADED,
  FEEDBACK_INSIGHTS_OUTLET_COMPARISON_FAILED,
} from './constants';

const initialState = {
  overview: {
    loading: false,
    error: null,
    data: null,
  },
  ratingTrend: {
    loading: false,
    error: null,
    data: null,
  },
  servicePeriod: {
    loading: false,
    error: null,
    data: null,
  },
  outletComparison: {
    loading: false,
    error: null,
    data: null,
  },
};

function feedbackInsightsReducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case FETCH_FEEDBACK_INSIGHTS_OVERVIEW:
      return { ...state, overview: { loading: true, error: null, data: null } };
    case FEEDBACK_INSIGHTS_OVERVIEW_LOADED:
      return { ...state, overview: { loading: false, error: null, data: payload } };
    case FEEDBACK_INSIGHTS_OVERVIEW_FAILED:
      return { ...state, overview: { loading: false, error, data: null } };

    case FETCH_FEEDBACK_INSIGHTS_RATING_TREND:
      return { ...state, ratingTrend: { loading: true, error: null, data: null } };
    case FEEDBACK_INSIGHTS_RATING_TREND_LOADED:
      return { ...state, ratingTrend: { loading: false, error: null, data: payload } };
    case FEEDBACK_INSIGHTS_RATING_TREND_FAILED:
      return { ...state, ratingTrend: { loading: false, error, data: null } };

    case FETCH_FEEDBACK_INSIGHTS_SERVICE_PERIOD:
      return { ...state, servicePeriod: { loading: true, error: null, data: null } };
    case FEEDBACK_INSIGHTS_SERVICE_PERIOD_LOADED:
      return { ...state, servicePeriod: { loading: false, error: null, data: payload } };
    case FEEDBACK_INSIGHTS_SERVICE_PERIOD_FAILED:
      return { ...state, servicePeriod: { loading: false, error, data: null } };

    case FETCH_FEEDBACK_INSIGHTS_OUTLET_COMPARISON:
      return { ...state, outletComparison: { loading: true, error: null, data: null } };
    case FEEDBACK_INSIGHTS_OUTLET_COMPARISON_LOADED:
      return { ...state, outletComparison: { loading: false, error: null, data: payload } };
    case FEEDBACK_INSIGHTS_OUTLET_COMPARISON_FAILED:
      return { ...state, outletComparison: { loading: false, error, data: null } };

    default:
      return state;
  }
}

export default feedbackInsightsReducer;
